import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["event", "children"];
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../services/proptypes';
import Event from '../Event';
var EventButton = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(EventButton, _React$PureComponent);
  var _super = _createSuper(EventButton);
  function EventButton() {
    _classCallCheck(this, EventButton);
    return _super.apply(this, arguments);
  }
  _createClass(EventButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        event = _this$props.event,
        children = _this$props.children,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Event, {
        event: event,
        eventType: "click"
      }, /*#__PURE__*/React.createElement(Button, rest, children));
    }
  }]);
  return EventButton;
}(React.PureComponent);
export { EventButton as default };
EventButton.defaultProps = {
  children: null
};